var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1219(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BlueDot_logo_rgb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 244,
    height: 80,
    viewBox: "0 0 244 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BLUEDOT_LOGO_RGB-2",
    "data-name": "BLUEDOT_LOGO_RGB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5746",
    "data-name": "Group 5746"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1737",
    "data-name": "Rectangle 1737",
    width: 244,
    height: 80,
    rx: 4,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5755",
    "data-name": "Group 5755",
    transform: "translate(10 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5749",
    "data-name": "Group 5749",
    transform: "translate(0.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5748",
    "data-name": "Group 5748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M30.043,68.6h3.4c9.548,0,12.163,6.341,12.163,9.81,0,8.894-5.3,10.2-11.246,10.2H30.043V68.6ZM23.37,112.543H17.16v1.047H39.526c6.149,0,14-3.531,14-12.359,0-8.3-7.258-11.377-14.388-11.966v-.131c4.709-.458,13.144-1.374,13.144-11.381,0-5.3-5.429-10.2-15.17-10.2H17.164V68.6h6.21v43.946Zm6.672-22.885h3.531c7.454,0,12.49,3.662,12.49,10.985,0,7.65-3.662,11.9-10.53,11.9h-5.49V89.658Z",
    transform: "translate(-17.16 -65.525)",
    fill: "#0054a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M115.376,109.308h-5.232v1.047H126.1v-1.047h-5.232V62.29c-1.309,1.505-3.4,1.632-5.494,1.632H110.14V64.97h5.232v44.339Z",
    transform: "translate(-74.341 -62.29)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M150.656,135.524c0,3.792,2.352,7.258,8.894,7.258,5.821,0,8.567-5.232,9.156-6.734h.131V142h10.723v-1.047h-5.232V113.744c-1.309,1.309-3.4,1.436-5.494,1.436h-5.167v1.047h5.167v15.5c0,4.84-4.054,10.007-8.632,10.007-2.483,0-4.054-1.767-4.054-4.578V113.74c-1.309,1.309-3.4,1.436-5.494,1.436H145.42v1.047h5.232v19.3Z",
    transform: "translate(-96.038 -93.931)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M237.806,125.726h17.068a.521.521,0,0,0,.589-.589c0-2.745-3.989-11.377-11.7-11.377-7.131,0-12.228,8.174-12.228,14.519,0,8.632,5.363,14.515,13.014,14.515,6.018,0,10.465-4.054,11.508-10.072H255a10.349,10.349,0,0,1-10.465,9.025c-6.145,0-6.8-5.232-6.734-9.876v-6.145Zm11.377-1.505a.413.413,0,0,1-.458.458H237.806V122.85c0-4.185,1.375-8.043,5.952-8.043,4.316,0,5.429,3.858,5.429,8.043v1.371Z",
    transform: "translate(-148.994 -93.943)",
    fill: "#0054a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M331.42,112.593h-6.21v1.047h20.533c13.406,0,22.235-8.763,22.235-23.02,0-8.7-4.905-23.02-22.3-23.02H325.21v1.047h6.21v43.946Zm6.669-43.946h3.2c16.024,0,19.228,10.788,19.228,21.973,0,19.748-10.919,21.973-16.806,21.973h-5.625V68.647Z",
    transform: "translate(-206.605 -65.556)",
    fill: "#e31937",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M514.647,124.692c0,4.316,3.007,5.821,7.589,5.821a7.152,7.152,0,0,0,7.192-4.971l-.978-.2c-.393,1.113-1.833,4.12-5.1,4.12-2.091,0-3.2-.851-3.2-3.531V103.963h9.025v-1.047h-9.029V93.76h-.785c-1.109,6.411-3.6,9.287-10.4,9.156v1.047h5.686v20.729Z",
    transform: "translate(-319.609 -81.644)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M572.172,161.67a5.4,5.4,0,0,0,0,10.807,5.4,5.4,0,1,0,0-10.807Z",
    transform: "translate(-355.16 -123.407)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5747",
    "data-name": "Group 5747",
    transform: "translate(162.027 20.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M483.93,125.24c.127.812.235,1.686.323,2.576h3.265a16.861,16.861,0,0,0-1-2.576Z",
    transform: "translate(-466.242 -121.205)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M481.31,115.31a12.516,12.516,0,0,1,.859,2.953h2.264A6.475,6.475,0,0,0,481.31,115.31Z",
    transform: "translate(-464.631 -115.098)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M484.97,134.2c.073.862.127,1.729.169,2.576h3.777a24.77,24.77,0,0,0-.516-2.576Z",
    transform: "translate(-466.882 -126.715)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M485.52,143.15c.035.912.058,1.786.065,2.58h3.962c-.019-.882-.081-1.744-.177-2.58Z",
    transform: "translate(-467.22 -132.219)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M469.4,118.273a12.421,12.421,0,0,1,.855-2.953,6.473,6.473,0,0,0-3.122,2.953Z",
    transform: "translate(-455.911 -115.104)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M485.61,152.11c0,.778-.015,1.652-.05,2.576h3.885c.081-.835.123-1.7.127-2.576Z",
    transform: "translate(-467.245 -137.73)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M452.318,163.64q-.277-1.236-.447-2.58H447.49a15.769,15.769,0,0,0,.832,2.58Z",
    transform: "translate(-443.832 -143.234)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M464.592,154.686c-.031-.924-.046-1.8-.046-2.576H460.58c.008.878.05,1.74.127,2.576Z",
    transform: "translate(-451.882 -137.73)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M485.234,161.06c-.038.843-.089,1.709-.154,2.58H488.6a24.585,24.585,0,0,0,.462-2.58Z",
    transform: "translate(-466.95 -143.234)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M466.585,127.826c.089-.893.2-1.763.323-2.576h-2.583a17.016,17.016,0,0,0-1,2.576Z",
    transform: "translate(-453.567 -121.211)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M455.384,172.6a19.79,19.79,0,0,1-.87-2.576h-3.8a14.4,14.4,0,0,0,1.648,2.576Z",
    transform: "translate(-445.813 -148.744)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M464.558,145.73c.008-.793.027-1.663.065-2.58h-3.85q-.144,1.253-.173,2.58Z",
    transform: "translate(-451.895 -132.219)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M465.117,136.776c.042-.847.1-1.717.173-2.576h-3.434a24.184,24.184,0,0,0-.516,2.576Z",
    transform: "translate(-452.35 -126.715)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M477.317,127.826c-.1-.959-.212-1.821-.335-2.576h-2.587c-.123.758-.239,1.617-.335,2.576Z",
    transform: "translate(-460.172 -121.211)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M473.92,170.02c.089.951.193,1.813.308,2.576h2.741c.112-.766.219-1.625.308-2.576Z",
    transform: "translate(-460.086 -148.744)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M475.08,178.97a9.414,9.414,0,0,0,1.067,3.538c.035,0,.069,0,.1,0,.077,0,.154,0,.231-.008a9.436,9.436,0,0,0,1.063-3.534Z",
    transform: "translate(-460.8 -154.248)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M477.593,117.929c-.385-2.014-.828-3.1-1.143-3.169h0c-.312.073-.751,1.155-1.136,3.169h2.283Z",
    transform: "translate(-460.941 -114.76)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M505.941,170.02a15.428,15.428,0,0,1-1.521,2.576h1.063a14.408,14.408,0,0,0,2.125-2.576Z",
    transform: "translate(-478.843 -148.744)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M446.671,154.686h4.462q-.116-1.253-.123-2.576h-4.57A16.631,16.631,0,0,0,446.671,154.686Z",
    transform: "translate(-443.187 -137.73)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M461.886,182.116a10.51,10.51,0,0,1-2.268-3.146H456.95A11.94,11.94,0,0,0,461.886,182.116Z",
    transform: "translate(-449.65 -154.248)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M445.318,170.02h-1.8a14.434,14.434,0,0,0,2.125,2.576h1.194A15.414,15.414,0,0,1,445.318,170.02Z",
    transform: "translate(-441.391 -148.744)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M487.778,170.02h-3.361c-.081.886-.177,1.756-.3,2.576h2.741A18.316,18.316,0,0,0,487.778,170.02Z",
    transform: "translate(-466.359 -148.744)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M461.622,163.64h3.515c-.065-.87-.119-1.736-.154-2.58H461.16A24.577,24.577,0,0,0,461.622,163.64Z",
    transform: "translate(-452.239 -143.234)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M476.985,163.64q.1-1.207.154-2.58H473.32c.039.916.092,1.775.154,2.58Z",
    transform: "translate(-459.717 -143.234)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M477.153,136.776q-.069-1.38-.173-2.576h-3.427c-.069.8-.127,1.659-.173,2.576Z",
    transform: "translate(-459.754 -126.715)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M466.6,172.6c-.116-.82-.216-1.69-.3-2.576H462.94a18.144,18.144,0,0,0,.916,2.576Z",
    transform: "translate(-453.334 -148.744)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M477.053,154.686c.027-.816.042-1.679.042-2.576H473.13q0,1.351.042,2.576Z",
    transform: "translate(-459.6 -137.73)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M477.1,145.73c-.008-.9-.027-1.763-.058-2.58h-3.85c-.031.816-.05,1.679-.058,2.58Z",
    transform: "translate(-459.6 -132.219)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M468.872,178.97H466.42a6.874,6.874,0,0,0,3.4,3.45A13.71,13.71,0,0,1,468.872,178.97Z",
    transform: "translate(-455.474 -154.248)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M452.5,178.97h-.9a15.465,15.465,0,0,0,2.66,1.729A13.586,13.586,0,0,1,452.5,178.97Z",
    transform: "translate(-446.36 -154.248)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M510.125,161.06a16.281,16.281,0,0,1-.785,2.58h1.813a13.171,13.171,0,0,0,1.074-2.58Z",
    transform: "translate(-481.869 -143.234)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M484.71,178.97h-2.453a13.546,13.546,0,0,1-.947,3.45A6.873,6.873,0,0,0,484.71,178.97Z",
    transform: "translate(-464.631 -154.248)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M442.4,163.64a16.281,16.281,0,0,1-.785-2.58H439.38a13.271,13.271,0,0,0,1.074,2.58Z",
    transform: "translate(-438.845 -143.234)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M440.6,154.686a17.646,17.646,0,0,1-.223-2.576H437.99a12.944,12.944,0,0,0,.308,2.576Z",
    transform: "translate(-437.99 -137.73)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M438.01,145.73H440.4a17.622,17.622,0,0,1,.3-2.58h-2.3A13.035,13.035,0,0,0,438.01,145.73Z",
    transform: "translate(-438.002 -132.219)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M509.68,136.776H511.8a13.233,13.233,0,0,0-1.155-2.576H508.81A15.837,15.837,0,0,1,509.68,136.776Z",
    transform: "translate(-481.543 -126.715)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M512.023,152.11a16.649,16.649,0,0,1-.223,2.576h2.168a12.992,12.992,0,0,0,.308-2.576Z",
    transform: "translate(-483.382 -137.73)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M441.9,136.776a16.088,16.088,0,0,1,.874-2.576h-1.964a13.435,13.435,0,0,0-1.155,2.576Z",
    transform: "translate(-439.017 -126.715)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M504.543,125.24H503.45a15.065,15.065,0,0,1,1.652,2.576H506.8A14.573,14.573,0,0,0,504.543,125.24Z",
    transform: "translate(-478.247 -121.205)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M445.9,127.826a15.3,15.3,0,0,1,1.652-2.576h-1.224a14.752,14.752,0,0,0-2.256,2.576Z",
    transform: "translate(-441.729 -121.211)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M511.58,143.15a17.621,17.621,0,0,1,.3,2.58h2.256a12.758,12.758,0,0,0-.381-2.58Z",
    transform: "translate(-483.247 -132.219)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M451.03,145.73c.019-.882.077-1.744.166-2.58h-4.42a16.577,16.577,0,0,0-.316,2.58Z",
    transform: "translate(-443.199 -132.219)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M500.189,178.97a14.086,14.086,0,0,1-1.529,1.54,15.317,15.317,0,0,0,2.295-1.54Z",
    transform: "translate(-475.301 -154.248)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M498.053,152.11q-.006,1.323-.123,2.576h4.462a16.178,16.178,0,0,0,.231-2.576Z",
    transform: "translate(-474.852 -137.73)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M496.983,161.06a25.889,25.889,0,0,1-.443,2.58h3.993a15.764,15.764,0,0,0,.832-2.58Z",
    transform: "translate(-473.997 -143.234)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M497.8,143.15q.139,1.253.166,2.58h4.566a16.185,16.185,0,0,0-.316-2.58Z",
    transform: "translate(-474.772 -132.219)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M491.726,178.97h-2.668a10.359,10.359,0,0,1-2.268,3.142A11.916,11.916,0,0,0,491.726,178.97Z",
    transform: "translate(-468.001 -154.248)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M494.584,170.02a19.608,19.608,0,0,1-.874,2.576h3.03a14.529,14.529,0,0,0,1.648-2.576Z",
    transform: "translate(-472.257 -148.744)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M496.23,134.2a25.237,25.237,0,0,1,.5,2.576h4.324a14.93,14.93,0,0,0-.928-2.576Z",
    transform: "translate(-473.807 -126.715)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M455.055,127.826a18.481,18.481,0,0,1,.951-2.576h-2.83a14.151,14.151,0,0,0-1.806,2.576Z",
    transform: "translate(-446.218 -121.211)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M452.67,120.284h.924a13.457,13.457,0,0,1,1.914-1.694A15.537,15.537,0,0,0,452.67,120.284Z",
    transform: "translate(-447.018 -117.115)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M462.685,116.1a11.776,11.776,0,0,0-4.435,2.649h2.422A10.093,10.093,0,0,1,462.685,116.1Z",
    transform: "translate(-450.45 -115.584)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M452.134,136.776a25.229,25.229,0,0,1,.5-2.576h-3.892a15.854,15.854,0,0,0-.928,2.576Z",
    transform: "translate(-444.029 -126.715)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M488.794,118.759h2.422a11.746,11.746,0,0,0-4.435-2.649A9.731,9.731,0,0,1,488.794,118.759Z",
    transform: "translate(-467.995 -115.59)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M497.11,119.02a13.41,13.41,0,0,1,1.686,1.529h.8A15.512,15.512,0,0,0,497.11,119.02Z",
    transform: "translate(-474.348 -117.38)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M493.15,125.24a18.661,18.661,0,0,1,.951,2.576h3.685a14.017,14.017,0,0,0-1.806-2.576Z",
    transform: "translate(-471.912 -121.205)",
    fill: "#0054a4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5753",
    "data-name": "Group 5753",
    transform: "translate(0 57.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5750",
    "data-name": "Group 5750",
    transform: "translate(58.088 0.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M172.509,218.377h-3.534l-.62,1.44a2.24,2.24,0,0,0-.227.793.454.454,0,0,0,.2.366,1.747,1.747,0,0,0,.859.2v.25H166.31v-.25a1.522,1.522,0,0,0,.739-.262,4.229,4.229,0,0,0,.762-1.313l3.211-7.516h.235l3.18,7.6a3.43,3.43,0,0,0,.7,1.19,1.433,1.433,0,0,0,.874.308v.25h-3.6v-.25a1.378,1.378,0,0,0,.739-.181.471.471,0,0,0,.193-.377,2.77,2.77,0,0,0-.27-.936Zm-.189-.5-1.548-3.692-1.59,3.692Z",
    transform: "translate(-166.31 -211.851)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M195.1,214.706v4.955a2.218,2.218,0,0,0,.085.77.588.588,0,0,0,.25.285,1.357,1.357,0,0,0,.6.1v.243h-3v-.243a1.384,1.384,0,0,0,.6-.089.6.6,0,0,0,.246-.289,2.142,2.142,0,0,0,.092-.774v-2.376a8.152,8.152,0,0,0-.062-1.3.548.548,0,0,0-.146-.3.4.4,0,0,0-.277-.085,1.392,1.392,0,0,0-.458.1l-.1-.243,1.86-.755h.293Zm-.562-3.226a.645.645,0,0,1,.481.2.683.683,0,0,1,0,.966.645.645,0,0,1-.481.2.684.684,0,0,1-.685-.685.645.645,0,0,1,.2-.481A.662.662,0,0,1,194.54,211.48Z",
    transform: "translate(-182.693 -211.476)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M204.225,219.86v1.386q.774-1.386,1.59-1.386a.866.866,0,0,1,.612.227.693.693,0,0,1,.243.524.6.6,0,0,1-.177.443.546.546,0,0,1-.416.181.881.881,0,0,1-.527-.231.872.872,0,0,0-.435-.231.4.4,0,0,0-.262.135,3.325,3.325,0,0,0-.628.909v2.957a1.828,1.828,0,0,0,.127.774.711.711,0,0,0,.308.3,1.358,1.358,0,0,0,.639.119v.243h-3.157v-.243a1.339,1.339,0,0,0,.7-.146.566.566,0,0,0,.235-.343,3.368,3.368,0,0,0,.035-.655v-2.391a10.488,10.488,0,0,0-.042-1.282.512.512,0,0,0-.162-.3.461.461,0,0,0-.293-.1,1.357,1.357,0,0,0-.47.1l-.065-.243,1.867-.755h.277Z",
    transform: "translate(-188.308 -216.63)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M231.834,212.1l.208,3.1h-.208a3.9,3.9,0,0,0-1.194-2.006,2.906,2.906,0,0,0-1.86-.612,2.883,2.883,0,0,0-2.8,1.933,6.539,6.539,0,0,0-.42,2.51,5.311,5.311,0,0,0,.4,2.148,2.976,2.976,0,0,0,1.2,1.394,3.435,3.435,0,0,0,1.821.485,3.164,3.164,0,0,0,1.571-.381,5.165,5.165,0,0,0,1.494-1.513l.208.135a4.824,4.824,0,0,1-1.6,1.786,4.06,4.06,0,0,1-2.175.566,4.122,4.122,0,0,1-3.515-1.683,4.809,4.809,0,0,1-.928-2.949,5.231,5.231,0,0,1,.612-2.51,4.436,4.436,0,0,1,1.686-1.775,4.56,4.56,0,0,1,2.349-.631,4.291,4.291,0,0,1,1.952.485,1.025,1.025,0,0,0,.4.146.446.446,0,0,0,.316-.127,1.073,1.073,0,0,0,.25-.5Z",
    transform: "translate(-201.807 -211.857)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M250.82,219.86a2.732,2.732,0,0,1,2.249,1.063,3.257,3.257,0,0,1,.72,2.087,3.933,3.933,0,0,1-.4,1.679,2.822,2.822,0,0,1-2.645,1.71,2.607,2.607,0,0,1-2.214-1.113,3.445,3.445,0,0,1-.693-2.1,3.715,3.715,0,0,1,.42-1.686,2.8,2.8,0,0,1,2.56-1.636Zm-.208.439a1.384,1.384,0,0,0-.716.212,1.487,1.487,0,0,0-.581.743,3.607,3.607,0,0,0-.223,1.367,4.771,4.771,0,0,0,.535,2.326,1.6,1.6,0,0,0,1.409.978,1.322,1.322,0,0,0,1.078-.539,3.077,3.077,0,0,0,.424-1.852,4.221,4.221,0,0,0-.708-2.587A1.455,1.455,0,0,0,250.612,220.3Z",
    transform: "translate(-216.45 -216.63)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M266.882,221.169a2.916,2.916,0,0,1,2.068-1.305,1.487,1.487,0,0,1,.87.254,1.691,1.691,0,0,1,.578.832,3.819,3.819,0,0,1,.146,1.24v2.634a2.142,2.142,0,0,0,.1.793.542.542,0,0,0,.239.262,1.364,1.364,0,0,0,.608.1v.243h-3.049v-.243h.127a1.025,1.025,0,0,0,.6-.131.688.688,0,0,0,.239-.389,3.734,3.734,0,0,0,.027-.631V222.3a2.539,2.539,0,0,0-.219-1.221.784.784,0,0,0-.739-.381,2.23,2.23,0,0,0-1.6.874v3.253a2.292,2.292,0,0,0,.073.774.606.606,0,0,0,.258.285,1.592,1.592,0,0,0,.67.092v.243H264.83v-.243h.135a.722.722,0,0,0,.635-.239,1.719,1.719,0,0,0,.166-.912v-2.291a9.869,9.869,0,0,0-.05-1.355.59.59,0,0,0-.154-.331.424.424,0,0,0-.281-.089,1.315,1.315,0,0,0-.451.1l-.1-.243,1.86-.755h.289v1.309Z",
    transform: "translate(-226.836 -216.63)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M287.967,220.36a3.15,3.15,0,0,1-.882.678,2.11,2.11,0,0,1-.928.2,2.287,2.287,0,0,1-1.763-.847,3.128,3.128,0,0,1-.755-2.171,3.922,3.922,0,0,1,.836-2.429,2.582,2.582,0,0,1,2.148-1.1,1.85,1.85,0,0,1,1.348.52v-1.14a9.214,9.214,0,0,0-.05-1.3.566.566,0,0,0-.158-.331.42.42,0,0,0-.27-.089,1.4,1.4,0,0,0-.466.108l-.089-.235,1.84-.755h.3V218.6a9.436,9.436,0,0,0,.05,1.324.62.62,0,0,0,.162.335.4.4,0,0,0,.258.1,1.476,1.476,0,0,0,.485-.116l.073.235-1.833.762h-.308v-.878Zm0-.474v-3.18a2.15,2.15,0,0,0-.243-.835,1.4,1.4,0,0,0-.535-.57,1.313,1.313,0,0,0-.651-.193,1.383,1.383,0,0,0-1.059.531,3.028,3.028,0,0,0-.612,2.048,3.2,3.2,0,0,0,.593,2.083,1.706,1.706,0,0,0,1.321.724A1.615,1.615,0,0,0,287.967,219.886Z",
    transform: "translate(-238.466 -211.47)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M303.572,214.706v4.955a2.217,2.217,0,0,0,.085.77.588.588,0,0,0,.25.285,1.357,1.357,0,0,0,.6.1v.243h-3v-.243a1.384,1.384,0,0,0,.6-.089.6.6,0,0,0,.246-.289,2.142,2.142,0,0,0,.092-.774v-2.376a8.141,8.141,0,0,0-.062-1.3.547.547,0,0,0-.146-.3.412.412,0,0,0-.277-.085,1.392,1.392,0,0,0-.458.1l-.1-.243,1.86-.755h.293Zm-.562-3.226a.645.645,0,0,1,.481.2.683.683,0,0,1,0,.966.645.645,0,0,1-.481.2.69.69,0,0,1-.689-.685.645.645,0,0,1,.2-.481A.678.678,0,0,1,303.01,211.48Z",
    transform: "translate(-249.4 -211.476)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M312.747,215.064v2.029h1.44v.47h-1.44v4a1.333,1.333,0,0,0,.173.809.549.549,0,0,0,.443.208.773.773,0,0,0,.431-.139.892.892,0,0,0,.323-.408h.262a2.146,2.146,0,0,1-.666.993,1.441,1.441,0,0,1-.889.335,1.175,1.175,0,0,1-.6-.173,1.053,1.053,0,0,1-.439-.493,2.534,2.534,0,0,1-.142-.986v-4.15h-.978v-.223a2.6,2.6,0,0,0,.758-.5,3.914,3.914,0,0,0,.689-.839,7.378,7.378,0,0,0,.431-.936h.208Z",
    transform: "translate(-255.083 -213.678)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M323.472,214.706v4.955a2.218,2.218,0,0,0,.085.77.588.588,0,0,0,.25.285,1.357,1.357,0,0,0,.6.1v.243h-3v-.243a1.384,1.384,0,0,0,.6-.089.6.6,0,0,0,.246-.289,2.142,2.142,0,0,0,.092-.774v-2.376a8.157,8.157,0,0,0-.062-1.3.548.548,0,0,0-.146-.3.412.412,0,0,0-.277-.085,1.393,1.393,0,0,0-.458.1l-.1-.243,1.86-.755h.293Zm-.558-3.226a.645.645,0,0,1,.481.2.683.683,0,0,1,0,.966.645.645,0,0,1-.481.2.69.69,0,0,1-.689-.685.645.645,0,0,1,.2-.481A.678.678,0,0,1,322.914,211.48Z",
    transform: "translate(-261.638 -211.476)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M334.4,219.86a2.732,2.732,0,0,1,2.249,1.063,3.257,3.257,0,0,1,.72,2.087,3.932,3.932,0,0,1-.4,1.679,2.822,2.822,0,0,1-2.645,1.71,2.619,2.619,0,0,1-2.218-1.113,3.445,3.445,0,0,1-.693-2.1,3.715,3.715,0,0,1,.42-1.686,2.8,2.8,0,0,1,2.564-1.636Zm-.208.439a1.384,1.384,0,0,0-.716.212,1.487,1.487,0,0,0-.581.743,3.607,3.607,0,0,0-.223,1.367,4.77,4.77,0,0,0,.535,2.326,1.6,1.6,0,0,0,1.413.978,1.322,1.322,0,0,0,1.078-.539,3.077,3.077,0,0,0,.423-1.852,4.221,4.221,0,0,0-.708-2.587A1.462,1.462,0,0,0,334.2,220.3Z",
    transform: "translate(-267.85 -216.63)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M350.482,221.169a2.916,2.916,0,0,1,2.068-1.305,1.487,1.487,0,0,1,.87.254,1.691,1.691,0,0,1,.578.832,3.819,3.819,0,0,1,.146,1.24v2.634a2.142,2.142,0,0,0,.1.793.543.543,0,0,0,.239.262,1.365,1.365,0,0,0,.608.1v.243h-3.049v-.243h.127a1.025,1.025,0,0,0,.6-.131.689.689,0,0,0,.239-.389,3.736,3.736,0,0,0,.027-.631V222.3a2.539,2.539,0,0,0-.219-1.221.784.784,0,0,0-.739-.381,2.23,2.23,0,0,0-1.6.874v3.253a2.292,2.292,0,0,0,.073.774.605.605,0,0,0,.258.285,1.592,1.592,0,0,0,.67.092v.243H348.43v-.243h.135a.722.722,0,0,0,.635-.239,1.719,1.719,0,0,0,.166-.912v-2.291a9.85,9.85,0,0,0-.05-1.355.59.59,0,0,0-.154-.331.424.424,0,0,0-.281-.089,1.316,1.316,0,0,0-.45.1l-.1-.243,1.86-.755h.289v1.309Z",
    transform: "translate(-278.249 -216.63)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M369.252,214.706v4.955a2.217,2.217,0,0,0,.085.77.588.588,0,0,0,.25.285,1.357,1.357,0,0,0,.6.1v.243h-3v-.243a1.384,1.384,0,0,0,.6-.089.6.6,0,0,0,.246-.289,2.141,2.141,0,0,0,.092-.774v-2.376a8.141,8.141,0,0,0-.062-1.3.548.548,0,0,0-.146-.3.412.412,0,0,0-.277-.085,1.392,1.392,0,0,0-.458.1l-.1-.243,1.86-.755h.293Zm-.558-3.226a.645.645,0,0,1,.481.2.683.683,0,0,1,0,.966.645.645,0,0,1-.481.2.69.69,0,0,1-.689-.685.645.645,0,0,1,.2-.481A.671.671,0,0,1,368.694,211.48Z",
    transform: "translate(-289.792 -211.476)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M378.342,221.169a2.916,2.916,0,0,1,2.068-1.305,1.487,1.487,0,0,1,.87.254,1.691,1.691,0,0,1,.578.832,3.817,3.817,0,0,1,.146,1.24v2.634a2.143,2.143,0,0,0,.1.793.543.543,0,0,0,.239.262,1.365,1.365,0,0,0,.608.1v.243H379.9v-.243h.127a1.025,1.025,0,0,0,.6-.131.689.689,0,0,0,.239-.389,3.74,3.74,0,0,0,.027-.631V222.3a2.538,2.538,0,0,0-.219-1.221.784.784,0,0,0-.739-.381,2.23,2.23,0,0,0-1.6.874v3.253a2.292,2.292,0,0,0,.073.774.605.605,0,0,0,.258.285,1.592,1.592,0,0,0,.67.092v.243H376.29v-.243h.135a.722.722,0,0,0,.635-.239,1.719,1.719,0,0,0,.166-.912v-2.291a9.865,9.865,0,0,0-.05-1.355.59.59,0,0,0-.154-.331.424.424,0,0,0-.281-.089,1.315,1.315,0,0,0-.45.1l-.1-.243,1.86-.755h.289v1.309Z",
    transform: "translate(-295.382 -216.63)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M396.647,223.977a2.072,2.072,0,0,1-.87-.77,2.036,2.036,0,0,1-.3-1.093,2.1,2.1,0,0,1,.689-1.575,2.462,2.462,0,0,1,1.767-.658,2.679,2.679,0,0,1,1.529.431h1.305a2.271,2.271,0,0,1,.339.015.109.109,0,0,1,.065.058.42.42,0,0,1,.039.216.6.6,0,0,1-.035.243.142.142,0,0,1-.069.054,1.627,1.627,0,0,1-.339.019h-.8a1.965,1.965,0,0,1,.377,1.24,1.944,1.944,0,0,1-.658,1.475,2.5,2.5,0,0,1-1.771.612,3.5,3.5,0,0,1-.936-.135,1.782,1.782,0,0,0-.4.447.721.721,0,0,0-.1.327.32.32,0,0,0,.112.223.8.8,0,0,0,.435.154c.127.019.439.035.943.046.924.023,1.525.054,1.8.1a1.682,1.682,0,0,1,1,.466,1.263,1.263,0,0,1,.374.928,1.957,1.957,0,0,1-.712,1.428,3.852,3.852,0,0,1-2.741.982,3.936,3.936,0,0,1-2.195-.585c-.339-.223-.5-.458-.5-.7a.759.759,0,0,1,.073-.323,3.967,3.967,0,0,1,.47-.693c.031-.039.262-.281.685-.728a2.152,2.152,0,0,1-.5-.373.558.558,0,0,1-.146-.373,1.1,1.1,0,0,1,.193-.551A4.4,4.4,0,0,1,396.647,223.977Zm-.065,2.249a3.261,3.261,0,0,0-.477.639,1.155,1.155,0,0,0-.162.547.685.685,0,0,0,.389.566,3.739,3.739,0,0,0,1.948.416,3,3,0,0,0,1.786-.427,1.174,1.174,0,0,0,.578-.913.506.506,0,0,0-.343-.5,4.489,4.489,0,0,0-1.386-.177A22.051,22.051,0,0,1,396.582,226.225Zm1.24-6.029a1.05,1.05,0,0,0-.836.4,1.862,1.862,0,0,0-.339,1.221,2.641,2.641,0,0,0,.458,1.652,1.087,1.087,0,0,0,.889.443,1.056,1.056,0,0,0,.843-.385,1.824,1.824,0,0,0,.331-1.205,2.693,2.693,0,0,0-.466-1.679A1.078,1.078,0,0,0,397.821,220.2Z",
    transform: "translate(-306.938 -216.642)",
    fill: "#e31937"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5751",
    "data-name": "Group 5751",
    transform: "translate(0 0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M18.047,216.469h4.243v-2.614a3.093,3.093,0,0,0-.089-.924.6.6,0,0,0-.285-.289,1.234,1.234,0,0,0-.612-.162H20.98v-.25h3.9v.25h-.323a1.268,1.268,0,0,0-.612.154.568.568,0,0,0-.293.327,3.322,3.322,0,0,0-.077.893v5.895a3.049,3.049,0,0,0,.089.916.62.62,0,0,0,.277.289,1.274,1.274,0,0,0,.62.162h.323v.25H20.98v-.25H21.3a.974.974,0,0,0,.816-.331,1.975,1.975,0,0,0,.169-1.036v-2.78H18.047v2.78a3.049,3.049,0,0,0,.089.916.611.611,0,0,0,.281.289,1.234,1.234,0,0,0,.612.162h.331v.25H15.444v-.25h.323a.972.972,0,0,0,.82-.331,2.043,2.043,0,0,0,.162-1.036v-5.895a3.093,3.093,0,0,0-.089-.924.62.62,0,0,0-.277-.289,1.274,1.274,0,0,0-.62-.162H15.44v-.25h3.912v.25h-.331a1.268,1.268,0,0,0-.612.154.588.588,0,0,0-.289.327,3.118,3.118,0,0,0-.081.893v2.614Z",
    transform: "translate(-15.44 -211.787)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M43,221.96a3.184,3.184,0,0,0,.666,2.156,2.041,2.041,0,0,0,1.582.782,1.717,1.717,0,0,0,1.055-.335,2.48,2.48,0,0,0,.751-1.14l.208.135a3.235,3.235,0,0,1-.82,1.679,2.2,2.2,0,0,1-1.706.759,2.488,2.488,0,0,1-1.9-.866,3.314,3.314,0,0,1-.793-2.326,3.507,3.507,0,0,1,.812-2.468,2.654,2.654,0,0,1,2.037-.886,2.274,2.274,0,0,1,1.706.685,2.513,2.513,0,0,1,.666,1.829H43Zm0-.393h2.857a2.609,2.609,0,0,0-.142-.835,1.35,1.35,0,0,0-.5-.593,1.277,1.277,0,0,0-.7-.216,1.4,1.4,0,0,0-1,.435A1.857,1.857,0,0,0,43,221.568Z",
    transform: "translate(-31.799 -216.227)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M61.318,224.923a9.546,9.546,0,0,1-1.194.847,1.831,1.831,0,0,1-.774.169A1.388,1.388,0,0,1,58.3,225.5a1.6,1.6,0,0,1-.416-1.151,1.467,1.467,0,0,1,.2-.782,2.7,2.7,0,0,1,.959-.862,14.779,14.779,0,0,1,2.272-.982v-.243a2.009,2.009,0,0,0-.293-1.267,1.061,1.061,0,0,0-.851-.343.964.964,0,0,0-.674.227.692.692,0,0,0-.254.524l.015.389a.673.673,0,0,1-.158.477.542.542,0,0,1-.416.169.532.532,0,0,1-.408-.173.693.693,0,0,1-.158-.477,1.374,1.374,0,0,1,.593-1.063,2.563,2.563,0,0,1,1.663-.485,2.882,2.882,0,0,1,1.348.277,1.255,1.255,0,0,1,.585.655,3.7,3.7,0,0,1,.119,1.186v2.095a9.364,9.364,0,0,0,.035,1.082.451.451,0,0,0,.112.266.257.257,0,0,0,.177.069.371.371,0,0,0,.189-.046,4.05,4.05,0,0,0,.547-.493v.377c-.5.674-.982,1.009-1.44,1.009a.654.654,0,0,1-.524-.227A1.284,1.284,0,0,1,61.318,224.923Zm0-.439v-2.349a13.265,13.265,0,0,0-1.313.574,2.278,2.278,0,0,0-.762.62,1.186,1.186,0,0,0-.227.708,1.153,1.153,0,0,0,.289.8.882.882,0,0,0,.666.32A2.463,2.463,0,0,0,61.318,224.484Z",
    transform: "translate(-41.54 -216.234)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M74.957,214.664v2.029H76.4v.47h-1.44v4a1.333,1.333,0,0,0,.173.809.549.549,0,0,0,.443.208.773.773,0,0,0,.431-.139.893.893,0,0,0,.323-.408h.262a2.146,2.146,0,0,1-.666.993,1.441,1.441,0,0,1-.889.335,1.175,1.175,0,0,1-.6-.173,1.053,1.053,0,0,1-.439-.493,2.534,2.534,0,0,1-.142-.986v-4.15H72.87v-.223a2.6,2.6,0,0,0,.758-.5,3.916,3.916,0,0,0,.689-.839,7.38,7.38,0,0,0,.431-.936h.208Z",
    transform: "translate(-50.758 -213.282)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M85.685,214.306v4.955a2.217,2.217,0,0,0,.085.77.588.588,0,0,0,.25.285,1.357,1.357,0,0,0,.6.1v.243h-3v-.243a1.416,1.416,0,0,0,.608-.089.6.6,0,0,0,.246-.289,2.142,2.142,0,0,0,.092-.774v-2.376a8.148,8.148,0,0,0-.062-1.3.548.548,0,0,0-.146-.3.4.4,0,0,0-.277-.085,1.392,1.392,0,0,0-.458.1l-.092-.243,1.86-.755h.285Zm-.558-3.226a.645.645,0,0,1,.481.2.683.683,0,0,1,0,.966.645.645,0,0,1-.481.2.684.684,0,0,1-.685-.685.684.684,0,0,1,.685-.681Z",
    transform: "translate(-57.32 -211.08)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M94.772,220.759a2.916,2.916,0,0,1,2.068-1.305,1.487,1.487,0,0,1,.87.254,1.691,1.691,0,0,1,.578.832,3.818,3.818,0,0,1,.146,1.24v2.633a2.142,2.142,0,0,0,.1.793.543.543,0,0,0,.239.262,1.365,1.365,0,0,0,.608.1v.243H96.328v-.243h.127a1.025,1.025,0,0,0,.6-.131.688.688,0,0,0,.239-.389,3.736,3.736,0,0,0,.027-.631v-2.526a2.539,2.539,0,0,0-.219-1.221.784.784,0,0,0-.739-.381,2.23,2.23,0,0,0-1.6.874v3.253a2.292,2.292,0,0,0,.073.774.605.605,0,0,0,.258.285,1.592,1.592,0,0,0,.67.092v.243H92.72v-.243h.135a.722.722,0,0,0,.635-.239,1.719,1.719,0,0,0,.166-.913v-2.291a9.858,9.858,0,0,0-.05-1.355.59.59,0,0,0-.154-.331.424.424,0,0,0-.281-.089,1.316,1.316,0,0,0-.45.1l-.1-.243,1.86-.755h.289v1.309Z",
    transform: "translate(-62.904 -216.227)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M113.077,223.567A2.025,2.025,0,0,1,111.9,221.7a2.1,2.1,0,0,1,.689-1.575,2.462,2.462,0,0,1,1.767-.658,2.678,2.678,0,0,1,1.529.431h1.305a2.16,2.16,0,0,1,.335.015.129.129,0,0,1,.069.058.42.42,0,0,1,.039.216.6.6,0,0,1-.035.243.141.141,0,0,1-.069.054,1.394,1.394,0,0,1-.339.019h-.8a1.965,1.965,0,0,1,.377,1.24,1.944,1.944,0,0,1-.658,1.475,2.5,2.5,0,0,1-1.771.612,3.5,3.5,0,0,1-.936-.135,1.783,1.783,0,0,0-.4.447.722.722,0,0,0-.1.327.32.32,0,0,0,.112.223.8.8,0,0,0,.435.154c.127.019.439.035.943.046.924.023,1.525.054,1.8.1a1.683,1.683,0,0,1,1,.466,1.263,1.263,0,0,1,.373.928,1.957,1.957,0,0,1-.712,1.428,3.852,3.852,0,0,1-2.741.982,3.936,3.936,0,0,1-2.195-.585c-.339-.223-.5-.458-.5-.7a.759.759,0,0,1,.073-.323,3.966,3.966,0,0,1,.47-.693c.031-.039.262-.281.689-.728a2.151,2.151,0,0,1-.5-.373.558.558,0,0,1-.146-.373,1.1,1.1,0,0,1,.193-.551A4.348,4.348,0,0,1,113.077,223.567Zm-.069,2.252a3.262,3.262,0,0,0-.477.639,1.156,1.156,0,0,0-.162.547.685.685,0,0,0,.389.566,3.73,3.73,0,0,0,1.944.42,3,3,0,0,0,1.786-.427,1.174,1.174,0,0,0,.578-.912.506.506,0,0,0-.343-.5,4.488,4.488,0,0,0-1.386-.177Q113.824,225.931,113.008,225.819Zm1.24-6.029a1.05,1.05,0,0,0-.835.4,1.863,1.863,0,0,0-.335,1.221,2.642,2.642,0,0,0,.458,1.652,1.087,1.087,0,0,0,.889.443,1.055,1.055,0,0,0,.843-.385,1.824,1.824,0,0,0,.331-1.205,2.693,2.693,0,0,0-.466-1.679A1.075,1.075,0,0,0,114.248,219.79Z",
    transform: "translate(-74.46 -216.24)",
    fill: "#e31937"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5752",
    "data-name": "Group 5752",
    transform: "translate(166.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M454.879,217.967h-3.534l-.62,1.44a2.24,2.24,0,0,0-.227.793.454.454,0,0,0,.2.366,1.748,1.748,0,0,0,.859.2v.25H448.68v-.25a1.522,1.522,0,0,0,.739-.262,4.229,4.229,0,0,0,.762-1.313l3.211-7.516h.235l3.18,7.6a3.43,3.43,0,0,0,.7,1.19,1.433,1.433,0,0,0,.874.308v.25h-3.6v-.25a1.378,1.378,0,0,0,.739-.181.471.471,0,0,0,.193-.377,2.77,2.77,0,0,0-.27-.936Zm-.189-.5-1.548-3.688-1.59,3.688Z",
    transform: "translate(-448.68 -211.441)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M476.612,220.759a2.916,2.916,0,0,1,2.068-1.305,1.487,1.487,0,0,1,.87.254,1.691,1.691,0,0,1,.577.832,3.819,3.819,0,0,1,.146,1.24v2.633a2.142,2.142,0,0,0,.1.793.543.543,0,0,0,.239.262,1.365,1.365,0,0,0,.608.1v.243h-3.049v-.243h.127a1.025,1.025,0,0,0,.6-.131.688.688,0,0,0,.239-.389,3.743,3.743,0,0,0,.027-.631v-2.526a2.54,2.54,0,0,0-.219-1.221.784.784,0,0,0-.739-.381,2.23,2.23,0,0,0-1.6.874v3.253a2.3,2.3,0,0,0,.073.774.605.605,0,0,0,.258.285,1.591,1.591,0,0,0,.67.092v.243H474.56v-.243h.135a.722.722,0,0,0,.635-.239,1.719,1.719,0,0,0,.166-.913v-2.291a9.852,9.852,0,0,0-.05-1.355.589.589,0,0,0-.154-.331.424.424,0,0,0-.281-.089,1.317,1.317,0,0,0-.451.1l-.1-.243,1.86-.755h.289v1.309Z",
    transform: "translate(-464.534 -216.22)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M497.7,219.95a3.1,3.1,0,0,1-.882.678,2.109,2.109,0,0,1-.928.2,2.287,2.287,0,0,1-1.763-.847,3.127,3.127,0,0,1-.755-2.171,3.922,3.922,0,0,1,.835-2.429,2.582,2.582,0,0,1,2.148-1.1,1.849,1.849,0,0,1,1.348.52v-1.14a9.2,9.2,0,0,0-.05-1.3.565.565,0,0,0-.158-.331.42.42,0,0,0-.27-.089,1.4,1.4,0,0,0-.466.108l-.089-.235,1.84-.755h.3v7.131a9.438,9.438,0,0,0,.05,1.324.619.619,0,0,0,.162.335.4.4,0,0,0,.258.1,1.476,1.476,0,0,0,.485-.115l.073.235-1.833.762H497.7v-.878Zm0-.47V216.3a2.15,2.15,0,0,0-.243-.835,1.4,1.4,0,0,0-.535-.57,1.314,1.314,0,0,0-.651-.193,1.382,1.382,0,0,0-1.059.531,3.027,3.027,0,0,0-.612,2.048,3.2,3.2,0,0,0,.593,2.083,1.706,1.706,0,0,0,1.321.724A1.622,1.622,0,0,0,497.7,219.48Z",
    transform: "translate(-476.164 -211.06)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M525.041,221.373l-3.531-7.685v6.1a1.885,1.885,0,0,0,.181,1.051,1,1,0,0,0,.789.281h.324v.25h-3.18v-.25h.323a.923.923,0,0,0,.82-.35,2.022,2.022,0,0,0,.146-.982v-5.968a2.092,2.092,0,0,0-.135-.874.738.738,0,0,0-.347-.327,1.851,1.851,0,0,0-.812-.131v-.25h2.587l3.315,7.146,3.261-7.146h2.587v.25h-.316a.933.933,0,0,0-.828.35,2.022,2.022,0,0,0-.146.982v5.968a1.8,1.8,0,0,0,.189,1.051,1,1,0,0,0,.789.281h.316v.25h-3.881v-.25h.323a.91.91,0,0,0,.82-.35,2.023,2.023,0,0,0,.146-.982v-6.1l-3.523,7.685Z",
    transform: "translate(-492.307 -211.786)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M555.09,219.46a2.732,2.732,0,0,1,2.249,1.063,3.257,3.257,0,0,1,.72,2.087,3.932,3.932,0,0,1-.4,1.679A2.822,2.822,0,0,1,555.017,226a2.607,2.607,0,0,1-2.214-1.113,3.445,3.445,0,0,1-.693-2.1,3.714,3.714,0,0,1,.42-1.686,2.8,2.8,0,0,1,2.56-1.636Zm-.208.439a1.384,1.384,0,0,0-.716.212,1.487,1.487,0,0,0-.581.743,3.608,3.608,0,0,0-.223,1.367,4.77,4.77,0,0,0,.535,2.326,1.6,1.6,0,0,0,1.409.978,1.322,1.322,0,0,0,1.078-.539,3.077,3.077,0,0,0,.424-1.852,4.221,4.221,0,0,0-.708-2.587A1.45,1.45,0,0,0,554.882,219.9Z",
    transform: "translate(-512.287 -216.226)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M571.184,219.46v1.386q.774-1.386,1.59-1.386a.866.866,0,0,1,.612.227.692.692,0,0,1,.243.524.6.6,0,0,1-.177.443.552.552,0,0,1-.416.181.881.881,0,0,1-.527-.231.873.873,0,0,0-.435-.231.4.4,0,0,0-.262.135,3.243,3.243,0,0,0-.628.909v2.957a1.827,1.827,0,0,0,.127.774.711.711,0,0,0,.308.3,1.358,1.358,0,0,0,.639.119v.243H569.1v-.243a1.339,1.339,0,0,0,.7-.146.565.565,0,0,0,.235-.343,3.369,3.369,0,0,0,.035-.655v-2.391a10.461,10.461,0,0,0-.042-1.282.512.512,0,0,0-.162-.3.461.461,0,0,0-.293-.1,1.357,1.357,0,0,0-.47.1l-.065-.243,1.864-.755h.281Z",
    transform: "translate(-522.699 -216.226)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M583.018,221.96a3.185,3.185,0,0,0,.666,2.156,2.041,2.041,0,0,0,1.582.782,1.717,1.717,0,0,0,1.055-.335,2.481,2.481,0,0,0,.751-1.14l.208.135a3.235,3.235,0,0,1-.82,1.679,2.2,2.2,0,0,1-1.706.759,2.489,2.489,0,0,1-1.9-.866,3.314,3.314,0,0,1-.793-2.326,3.507,3.507,0,0,1,.812-2.468,2.654,2.654,0,0,1,2.037-.886,2.274,2.274,0,0,1,1.706.685,2.513,2.513,0,0,1,.666,1.829h-4.262Zm0-.393h2.857a2.609,2.609,0,0,0-.142-.835,1.351,1.351,0,0,0-.5-.593,1.277,1.277,0,0,0-.7-.216,1.4,1.4,0,0,0-1,.435A1.877,1.877,0,0,0,583.018,221.568Z",
    transform: "translate(-530.706 -216.22)",
    fill: "#e31937"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M145.229,222.6a1.679,1.679,0,1,1-1.679,1.679A1.683,1.683,0,0,1,145.229,222.6Z",
    transform: "translate(-94.225 -218.157)",
    fill: "#0054a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M427.179,222.6a1.679,1.679,0,1,1-1.679,1.679A1.683,1.683,0,0,1,427.179,222.6Z",
    transform: "translate(-267.62 -218.157)",
    fill: "#0054a4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5754",
    "data-name": "Group 5754",
    transform: "translate(203.124 12.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M546.359,100.452a3.361,3.361,0,1,1,3.38-3.342A3.331,3.331,0,0,1,546.359,100.452Zm.031-6.422A3.057,3.057,0,1,0,549.44,97.1,3.049,3.049,0,0,0,546.39,94.03Zm-.077.947a2.677,2.677,0,0,1,.982.1,1.019,1.019,0,0,1-.3,1.964.979.979,0,0,1,.681.924,3.445,3.445,0,0,0,.312,1.217h-.708a2.069,2.069,0,0,1-.169-.578c-.019-.1-.085-.566-.1-.67-.123-.624-.462-.7-1.067-.708h-.3v1.952h-.612v-4.2Zm-.67,1.756h.708c.266,0,.962.008.962-.662a.6.6,0,0,0-.2-.462c-.181-.162-.385-.162-.9-.162h-.578v1.286Z",
    transform: "translate(-543.01 -93.73)",
    fill: "#0054a4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1219);
export default __webpack_public_path__ + "static/media/logo_1219.d1176c2a0864e5cf100fb7c681de129f.svg";
export { ForwardRef as ReactComponent };